<div class="flex items-center relative">
    <input type="text" class=" inputStyleCandidateRegister xs:text-xxs lg:text-base invalid:text-secondary_Light_Text_Color"
        onkeypress="return false" placeholder="Select year" (click)="togglePopover()" [value]="selectedYear"
        [class.has-value]="selectedYear" readonly />
    <div class="custom-popover" *ngIf="isPopoverOpen" appClickOutside (clickOutside)="this.isPopoverOpen=false" (click)="$event.stopPropagation()">
        <div class="p-2.5">
            <!-- Year Picker Header -->
            <div class="flex poppinsRegular">
                <div>
                    {{ startYear }} - {{ endYear }}
                </div>
                <div class="ml-auto">
                    <div class="flex gap-3">
                        <div>
                            <!-- Previous Year Button -->
                            <button [disabled]="startYear <= 1900" type="button" (click)="previousYears()"
                                class="arrow-button w-full">
                                <!-- <span class="arrow left">&#9664;</span> -->
                                <i class='bx bx-chevron-left'></i>
                            </button>
                        </div>
                        <div>
                            <!-- Next Year Button -->
                            <button [disabled]="endYear >= currentYear" type="button" (click)="nextYears()"
                                class="arrow-button w-full">
                                <!-- <span class="arrow right">&#9654;</span> -->
                                <i class='bx bx-chevron-right'></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="my-1">
                <hr>
            </div>

            <!-- Year List as Bubbles -->
            <div id="yearList" class="xs:h-64 xs:overflow-y-scroll md:h-auto md:overflow-hidden p-2 text-center grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                <div class="year-bubble poppinsRegular" *ngFor="let year of years" (click)="selectYear(year)"
                    [ngClass]="{'selected': +selectedYear === year}">
                    {{ year }}
                </div>
            </div>


        </div>
    </div>
</div>